import { render, staticRenderFns } from "./ProjectsOld.vue?vue&type=template&id=35bce5e8"
import script from "./ProjectsOld.vue?vue&type=script&lang=js"
export * from "./ProjectsOld.vue?vue&type=script&lang=js"
import style0 from "./ProjectsOld.vue?vue&type=style&index=0&id=35bce5e8&prod&lang=less"
import style1 from "./ProjectsOld.vue?vue&type=style&index=1&id=35bce5e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports